import { normalizeSpecialistRoleKey } from './activeSpecialistRoleHelper';

export const GENERATION_PHASE_BY_ROLE = {
  'pre-manager': {
    key: 'flow.generation-phase.exploration',
    fallback: 'Exploración Inicial'
  },
  manager: {
    key: 'flow.generation-phase.survey',
    fallback: 'Relevamiento de Información'
  },
  validator: {
    key: 'flow.generation-phase.cleanup',
    fallback: 'Limpieza de Datos'
  },
  editor: {
    key: 'flow.generation-phase.editing',
    fallback: 'Edición de Textos'
  },
  liaison: {
    key: 'flow.generation-phase.update',
    fallback: 'Actualización de Datos'
  },
  coordinator: {
    key: 'flow.generation-phase.supervision',
    fallback: 'Supervisión'
  }
};

export const resolveGenerationPhaseRoleKey = (roleLike) => {
  if (!roleLike) {
    return '';
  }
  if (typeof roleLike === 'string') {
    return normalizeSpecialistRoleKey({
      roleKey: roleLike,
      name: roleLike,
      code: roleLike
    }) || '';
  }
  return normalizeSpecialistRoleKey(roleLike) || '';
};

export const resolveGenerationPhaseMeta = (roleLike) => {
  const roleKey = resolveGenerationPhaseRoleKey(roleLike);
  return GENERATION_PHASE_BY_ROLE[roleKey] || null;
};

export const resolveGenerationPhaseLabel = (roleLike, t) => {
  const meta = resolveGenerationPhaseMeta(roleLike);
  if (!meta) {
    return '';
  }
  return t(meta.key, meta.fallback);
};

export const composeFlowEditPageTitle = ({
  t,
  moduleProcess,
  pageKey = 'edit',
  roleLike,
  flowEnabled
}) => {
  const base = t(`${moduleProcess}.page.${pageKey}`);
  if (!flowEnabled) {
    return base;
  }
  const phase = resolveGenerationPhaseLabel(roleLike, t);
  if (!phase) {
    return base;
  }
  return t('flow.edit-title.with-phase', {
    title: base,
    phase,
    defaultValue: `${base} - ${phase}`
  });
};
